<script setup lang="ts">
import { ref, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { HelpCircle, Compass, BookOpen, X } from 'lucide-vue-next'
import { getTourByRoute } from '@/tours'

const emit = defineEmits<{
  (e: 'start-tour'): void
  
}>()

const router = useRouter()
const route = useRoute()

const open = ref(false)

const hasTour = computed(() => {
  return route.name ? Boolean(getTourByRoute(String(route.name))) : false
})

const toggle = () => {
  open.value = !open.value
}

const goToHelp = () => {
  open.value = false
  void router.push('/help')
}

const handleStartTour = () => {
  open.value = false
  emit('start-tour')
}

const resetTours = () => {
  open.value = false
  localStorage.removeItem('toursCompleted')
  location.reload()
}
</script>

<template>
  <div class="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-[9999] flex flex-col items-end gap-2">
    <!-- Panel desplegable -->
    <Transition
      enter-active-class="transition-all duration-200 ease-out"
      enter-from-class="opacity-0 translate-y-2 scale-95"
      enter-to-class="opacity-100 translate-y-0 scale-100"
      leave-active-class="transition-all duration-150 ease-in"
      leave-from-class="opacity-100 translate-y-0 scale-100"
      leave-to-class="opacity-0 translate-y-2 scale-95"
    >
      <div
        v-if="open"
        class="z-[10000] bg-popover border border-border rounded-lg shadow-xl w-[calc(100vw-2rem)] max-w-56 p-1 origin-bottom-right"
      >
        <div class="px-2 py-1.5 text-xs uppercase tracking-wider text-muted-foreground font-medium">
          Ayuda
        </div>
        <div class="h-px bg-border my-1" />

        <button
          class="w-full flex items-center gap-2 px-2 py-1.5 text-sm rounded-sm hover:bg-accent transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          :disabled="!hasTour"
          @click="handleStartTour"
        >
          <Compass class="h-4 w-4 shrink-0" />
          Tour de esta vista
        </button>

        <button
          class="w-full flex items-center gap-2 px-2 py-1.5 text-sm rounded-sm hover:bg-accent transition-colors"
          @click="goToHelp"
        >
          <BookOpen class="h-4 w-4 shrink-0" />
          Todas las guías
        </button>

        <div class="h-px bg-border my-1" />

        <button
          class="w-full flex items-center gap-2 px-2 py-1.5 text-sm rounded-sm hover:bg-accent transition-colors text-muted-foreground"
          @click="resetTours"
        >
          <X class="h-4 w-4 shrink-0" />
          Reiniciar tours
        </button>
      </div>
    </Transition>

    <!-- Botón FAB -->
    <button
      class="h-12 w-12 sm:h-14 sm:w-14 rounded-full bg-primary text-primary-foreground shadow-xl hover:scale-110 focus-visible:ring-2 focus-visible:ring-ring transition-transform duration-200 flex items-center justify-center"
      aria-label="Centro de ayuda"
      :aria-expanded="open"
      @click="toggle"
    >
      <HelpCircle class="h-5 w-5 sm:h-6 sm:w-6" />
    </button>
  </div>
</template>
